'use client';

import { NextIntlClientProvider } from 'next-intl';
import type { Locale, Messages } from 'next-intl';
import type { PropsWithChildren } from 'react';

interface ScopedIntlClientProviderProps extends PropsWithChildren {
  locale: Locale;
  messages: Messages;
  timeZone: string;
}

export function ScopedIntlClientProvider({
  children,
  locale,
  messages,
  timeZone,
}: ScopedIntlClientProviderProps) {
  return (
    <NextIntlClientProvider
      locale={locale}
      messages={messages}
      timeZone={timeZone}
    >
      {children}
    </NextIntlClientProvider>
  );
}
